import React from "react";

const About = () => {
	return (
		<section className="section about-section">
			<h1 className="secction-title">About Us</h1>
			<p>
				Lorem ipsum dolor sit amet consectetur, adipisicing elit. Consequatur
				tenetur reprehenderit quaerat suscipit rerum perferendis, nostrum
				asperiores quia labore aliquam neque cumque soluta? At fugiat libero
				laboriosam voluptate! Facere expedita excepturi iure molestias
				necessitatibus possimus inventore aperiam nisi maiores, ab dolor eveniet
				qui quisquam ut nulla dicta sunt. Excepturi ipsam omnis repudiandae aut
				explicabo, aspernatur doloremque placeat distinctio. Sequi neque
				quisquam facere. Rem accusamus deserunt a sed. Aspernatur eligendi
				facere debitis reiciendis rem sapiente sed illum, veritatis in!
				Repudiandae nisi facilis tempore deserunt dolorem veritatis, consequatur
				commodi ipsam, officiis veniam eligendi rem! Officiis unde, dolore harum
				vel aliquam hic. Quibusdam?
			</p>
		</section>
	);
};

export default About;
